import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from '@mui/icons-material/Add';
import { createTheme } from '@mui/material/styles';

import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4GenericField from './Bs4GenericField';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4Stores from '../../Bs4Stores';
import * as Bs4Utils from '../../Bs4Components/Bs4Utils';
import Bs4I18N from '../../Bs4I18N';

const minSearchTextLength = 3;

export default class KontrolkaWybor extends Bs4GenericField {

  atrybOnchange = Bs4GenericField.CHANGE;

  setValueBs4(value) {    
    if (Array.isArray(value) && value.length > 0) value = value[0];
    if (Bs4Utils.isObject(value)) {
      if ('id' in value && 'name' in value) this.setValue(Bs4Stores.getNormalizedIdName(value.id, value.name));
      else this.setValue(null);
    }
    else if (value) this.setValueIds([value]);
  }

  getValueBs4 () {    
    return this?.value?.id || '';
  }

  isNativelyClearable () {
    return true;
  }
  
  getShortValue = () => {
    return this.getValue()?.name;
  }
  
  setValue (newValue) {
    super.setValue(newValue);
  }

  setValueIds = (newValueId) => {
    if (Array.isArray(newValueId) && newValueId.length > 0) newValueId = String(newValueId[0]);
    else newValueId = null
    
    if (this.getValue()?.id === newValueId) return;

    if (!newValueId) {
      this.setValue(null);
      return;
    }
    const newValue = {
      id: newValueId,
      name: String(newValueId),
    }
        
    this.setValue(newValue);
    return this.getData([newValueId], null);
  }

  getDataP = (currentFormElementValue, inputValue) => {
    const url = Bs4MainDispatch.getUrlPath('web.php');
    const data = { 
      com: 'Bs4SearchText',
      currFormId: this.props.field.formId,
      inputId: this.props.inputId,
      currCardViewId: null,
      currOptionId: this.props.optionId,
      page: 1,
      start: 0,
      limit: 200,
    }

    const newData = Bs4MainDispatch.getParserParams(data, this.props.bs4KartotekaId)

    const queryUrl = new URLSearchParams();
    queryUrl.append('com', 'Bs4SearchText');
    queryUrl.append('currFormId', newData.currFormId);
    queryUrl.append('_dc', Date.now());
    queryUrl.append('inputId', newData.inputId);      
    queryUrl.append('currCardViewId', newData.currCardViewId);
    queryUrl.append('currOptionId', newData.currOptionId);
    if (currentFormElementValue) 
      queryUrl.append('currentFormElementValue', JSON.stringify(currentFormElementValue));
    if (inputValue) 
      queryUrl.append('query', inputValue);
    queryUrl.append('page', newData.page);
    queryUrl.append('start', newData.start);
    queryUrl.append('limit', newData.limit);    

    fetch(url+'?'+queryUrl.toString())
    .then(response => {
      return response.text();
    })
    .then(returnedText => {
      try {
        const returnedJson = JSON.parse(returnedText);
        if (currentFormElementValue) {
          returnedJson.messgs.data.forEach(object => {            
            const item = Bs4Stores.getNormalizedIdName(object.id, object.name);
            if (this.getValue()?.id === item.id) this.setValue(item);
          });
        } else {
          this.trigger(Bs4GenericField.CHANGE_OPTIONS_SINGLE, this, inputValue, returnedJson.messgs.data);
        }
      } catch (error) {          
        console.log(returnedText, data);
        console.log(error);
      }
    })
    .catch((error) => {
      console.log(error);
    });
  }

  getData = (currentFormElementValue, inputValue) => {
    return new Promise((resolve, reject) => {
      const url = Bs4MainDispatch.getUrlPath('web.php');
      const data = { 
        com: 'Bs4SearchText',
        currFormId: this.props.field.formId,
        inputId: this.props.inputId,
        currCardViewId: null,
        currOptionId: this.props.optionId,
        page: 1,
        start: 0,
        limit: 200,
      }

      const newData = Bs4MainDispatch.getParserParams(data, this.props.bs4KartotekaId)

      const queryUrl = new URLSearchParams();
      queryUrl.append('com', 'Bs4SearchText');
      queryUrl.append('currFormId', newData.currFormId);
      queryUrl.append('_dc', Date.now());
      queryUrl.append('inputId', newData.inputId);      
      queryUrl.append('currCardViewId', newData.currCardViewId);
      queryUrl.append('currOptionId', newData.currOptionId);
      if (currentFormElementValue) 
        queryUrl.append('currentFormElementValue', JSON.stringify(currentFormElementValue));
      if (inputValue) 
        queryUrl.append('query', inputValue);
      queryUrl.append('page', newData.page);
      queryUrl.append('start', newData.start);
      queryUrl.append('limit', newData.limit);    

      fetch(url+'?'+queryUrl.toString())
      .then(response => {
        return response.text();
      })
      .then(returnedText => {
        try {
          const returnedJson = JSON.parse(returnedText);
          if (currentFormElementValue) {
            returnedJson.messgs.data.forEach(object => {            
              const item = Bs4Stores.getNormalizedIdName(object.id, object.name);
              object.id = item.id;
              object.name = item.name;
              if (this.getValue()?.id === item.id) this.setValue(item);
            });
          } else {
            this.trigger(Bs4GenericField.CHANGE_OPTIONS_SINGLE, this, inputValue, returnedJson.messgs.data);
          }
          resolve (true);
        } catch (error) {          
          console.log(returnedText, data);
          console.log(error);
          reject(error);
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  }

  getValueOptions(value, options) {    
    if (!value) return options;
    return [value, ...options.filter(option => option.id !== value?.id)]
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [options, setOptions] = React.useState(() => {
      const value = this.getValue();
      return Boolean(value) ? [value] : [];
    });
    const [inputValue, setInputValue] = React.useState(() => {
      const value = this.getValue();
      return Boolean(value) ? value.name : '';
    });
    const [open, setOpen] = React.useState(false);    
    const [loading, setLoading] = React.useState(false);
    const [
      enterTextOrClickTheSearchIcon, 
      noResultsFound
    ] = Bs4I18N.useTTA([
      ['Enter text or click the search icon', 'Wpisz szukany tekst lub kliknij lupę', 'KontrolkaWybor'],
      ['No results found', 'Nie znaleziono wyników', 'KontrolkaWybor'],
    ])
    
    this.refFocus = React.useRef();    

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})} 
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })
      
      this.on(Bs4GenericField.CHANGE_OPTIONS_SINGLE, (field, query, options) => {        
        setLoading(false);        
        const newOptions = (options || []).map(option => Bs4Stores.getNormalizedIdName(option.id, option.name));
        setOptions(newOptions);
      })     
    }, [error]);
    
    const theme = createTheme({})

    const canOpen = () => {
      return open && (options?.length > 1 || value?.name != inputValue);
    }

    const handleOpen = (event) => {
      setOpen(true);
    }

    const handleClose = (event) => {
      setOpen(false);
    }
    
    const handleInputChange = (event, newInputValue) => {      
      setInputValue(newInputValue || '');      
    }

    const getNoOptionsText = () => {
      return (inputValue || '').length < minSearchTextLength ? enterTextOrClickTheSearchIcon : noResultsFound;
    }

    const handleSearch = (e) => {
      const bs4Kartoteka = Bs4Kartoteka.get(this.props.bs4KartotekaId);
      bs4Kartoteka.sourceField = {query: 'search_single', field: this}
      Bs4MainDispatch.commandParser('Bs4FieldIconSearch', { currFormId: this.props.field.formId, inputId: this.props.field.inputId}, this.props.bs4KartotekaId);      
    }

    const handleAdd = (e) => {
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.props.field.formId }, this.props.bs4KartotekaId);
    }
    
    React.useEffect(() => {
      if (inputValue && inputValue?.length > 0 && inputValue?.length < minSearchTextLength) return;
      // if (!inputValue || inputValue?.length < minSearchTextLength) return;
      // console.log('...???...', inputValue);
      const value = this.getValue();
      if (value?.name == inputValue) return;
      this.getData(null, inputValue);
      setLoading(true);
    }, [inputValue]);

    const getAdornment = () => { 
      if (formField.readOnly) return null;
      return (      
        <Box display='flex' direction='column' sx={{border:"0px solid blue"}}>
          <IconButton onClick={handleSearch}><SearchIcon fontSize='small'/></IconButton>
          {formField.isParamSelected('ATRYB_PLUS') ? <IconButton onClick={handleAdd}><AddIcon fontSize='small'/></IconButton> : null}
        </Box>
      )
    }

    return (
      <Box 
        width='100%'
        sx={{display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap'}}
      >
        <Autocomplete          
          readOnly={this.readOnly}
          freeSolo={this.readOnly}
          //fullWidth 
          sx={{flex: 1}}
          disableCloseOnSelect
          value={value}
          //disableClearable={!formField.props.criterion}
          onChange={(event, newValue) => {
            this.setValue(newValue);
            setOpen(false);
          }}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          open={canOpen()}
          onOpen={handleOpen}
          onClose={handleClose}
          options={this.getValueOptions(value, options)}
          noOptionsText={getNoOptionsText()} //textArray[noOptionsText]}
          loading={loading}
          getOptionLabel={option => option?.name || ''}
          popupIcon={null} // bez popup
          isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
          renderInput={(params) => {
            params.InputProps.disableUnderline = formField.readOnly;
            return (
            <TextField 
              {...params} 
              label={<formField.Bs4Label/>}
              slotProps={{
                inputLabel: this.props.field.hideLabel ? {sx:{display:'none'}} : null,
              }}
              inputRef={this.refFocus} 
              error={error.error} 
              helperText={error.helperText}              
            />
          )}}
          renderOption={(props, option, { selected }) => (
            <MenuItem {...props} key={option.id}>
              <DoneIcon htmlColor={selected ? theme.palette.primary.main : 'transparent'}/>
              <span>&nbsp;</span>
              <ListItemText primary={option.name}/>
            </MenuItem>
          )}                  
          slotProps={{
            popper: { 
              sx: { minWidth: 'fit-content' },
              placement: "bottom-start",
            }
          }}
          // componentsProps={{ 
          //   popper: { 
          //     sx: { minWidth: 'fit-content' },
          //     placement: "bottom-start",
          //   }
          // }}          
        />
        {getAdornment()}
      </Box>
    );
  }
}